const mindboxEvents = require("./mindboxEvents");

const AUTH_FROM_STEP_EVENT = 'authFromStepEvent';
const AUTH_FROM_MENU_EVENT = 'authFromMenuEvent';
const ON_STEP_2_EVENT = 'onStep2Event';
const ON_CREATE_ORDER_EVENT = 'onCreateOrderEvent';
const ON_CREATE_PAYMENT_EVENT = 'onCreatePaymentEvent';
const ON_AFTER_PAYMENT_EVENT = 'onAfterPaymentEvent';
const ON_ORDER_STATUS_CHANGE_EVENT = 'onOrderStatusChangeEvent';

const eventTypesRuMindbox = {
    [AUTH_FROM_STEP_EVENT]: mindboxEvents.AuthorizeCustomer,
    [AUTH_FROM_MENU_EVENT]: mindboxEvents.AuthorizeCustomer,
    [ON_CREATE_ORDER_EVENT]: mindboxEvents.CreateorUpdateAuthorizedOrder,
    [ON_AFTER_PAYMENT_EVENT]: mindboxEvents.CreateorUpdateAuthorizedOrder,
    [ON_ORDER_STATUS_CHANGE_EVENT]: mindboxEvents.UpdateOrderStatus,
}

const eventTypesRuCarrot = {
    [AUTH_FROM_STEP_EVENT]: 'Авторизация после выбора продукта',
    [AUTH_FROM_MENU_EVENT]: 'Авторизация через меню',
    [ON_STEP_2_EVENT]: 'Брошенная корзина #eventType# - Шаг 1 - Данные о выбранном товаре',
    [ON_CREATE_ORDER_EVENT]: 'Брошенная корзина #eventType# - Шаг 2 - Данные участника',
    [ON_CREATE_PAYMENT_EVENT]: 'Брошенная корзина #eventType# - Шаг 3 - Данные заказа',
    [ON_AFTER_PAYMENT_EVENT]: 'Брошенная корзина #eventType# - Шаг 4 - Оплата',
}

const eventTypesEnCarrot = {
    [AUTH_FROM_STEP_EVENT]: 'Authorization after picked product',
    [AUTH_FROM_MENU_EVENT]: 'Authorization from menu',
    [ON_STEP_2_EVENT]: 'Abandoned cart #eventType# - Step 1 - Data of picked product',
    [ON_CREATE_ORDER_EVENT]: 'Abandoned cart #eventType# - Step 2 - Member data',
    [ON_CREATE_PAYMENT_EVENT]: 'Abandoned cart #eventType# - Step 3 - Order details',
    [ON_AFTER_PAYMENT_EVENT]: 'Abandoned cart #eventType# - Step 4 - Payment',
}

const carrotEventTypesLangAdapter = {
    en: eventTypesEnCarrot,
    ru: eventTypesRuCarrot,
}

const mindboxEventTypesLangAdapter = {
    ru: eventTypesRuMindbox,
}

module.exports = {
    eventTypes: {
        AUTH_FROM_STEP_EVENT,
        AUTH_FROM_MENU_EVENT,
        ON_STEP_2_EVENT,
        ON_CREATE_ORDER_EVENT,
        ON_CREATE_PAYMENT_EVENT,
        ON_AFTER_PAYMENT_EVENT,
        ON_ORDER_STATUS_CHANGE_EVENT,
    },
    carrotEventTypesLangAdapter,
    mindboxEventTypesLangAdapter,
}
